<div
	*ngIf="Processing == false"
	[ngClass]="{
		'se-Entry': true,
		'se-NormalScan': PersonTypeID == 1,
		'se-StaffScan': PersonTypeID == 2,
		'se-Alert1Scan': AlertSeverity == 1,
		'se-Alert2Scan': AlertSeverity == 2,
		'se-Alert3Scan': AlertSeverity == 3
	}"
>
	<div class="se-PictureMenu">
		<h2 class="se-FlexItem se-ModeText">{{ ScannerNBR }}</h2>

		<img id="MainImg" class="se-Image" [src]="PhotoData" />
		<!-- <img class="se-Image" src="{{PhotoData}}"> -->

		<!--Images on top right side-->
		<div class="se-FlexItem se-SideImages">
			<img class="se-SideIco" *ngIf="ShowIcoAttendance" id="IcoAttendance" src="assets/images/ScanPointImages/IcoAttendance.png" />
			<img class="se-SideIco" *ngIf="ShowIcoError" id="IcoError" src="assets/images/ScanPointImages/IcoError.png" />
			<img
				class="se-SideIco"
				*ngIf="ShowIcoHallPass"
				style="cursor: pointer"
				(click)="onHallPass()"
				id="IcoError"
				src="assets/images/ScanPointImages/IcoHallPass.png"
			/>
			<img class="se-SideIco" *ngIf="ShowIcoInfo" id="IcoError" src="assets/images/ScanPointImages/IcoInfo.png" />
			<img class="se-SideIco" *ngIf="ShowIcoPlus" id="IcoError" src="assets/images/ScanPointImages/IcoPlus.png" />
			<img class="se-SideIco" *ngIf="ShowIcoQuestion" id="IcoQuestion" src="assets/images/ScanPointImages/IcoQuestion.png" />
			<img class="se-SideIco" *ngIf="ShowIcoWarning" id="IcoWarning" src="assets/images/ScanPointImages/IcoWarning.png" />
		</div>
	</div>

	<div class="se-Text">
		<label>{{ PersonName }}</label>
		<!-- <label>{{barcode}}</label> -->
		<label>{{ DesignatorID }}</label>
		<label
			id="StatusText"
			[ngClass]="{
				'se-SpecialText': PersonTypeID == 1,
				'se-SpecialTextInstructor': PersonTypeID == 2,
				'se-SpecialTextBadEntry': PersonTypeID == -1
			}"
			>{{ Status }}</label
		>
	</div>

	<div class="se-AlertBar">
		<!-- <label>{{Alert1}}</label> -->
		<select class="form-control" name="Alert" [style.color]="SelectedAlert?.MessageFontColor" [(ngModel)]="SelectedAlert">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstAlerts" [ngValue]="o" [style.color]="o.MessageFontColor">
				{{ o.Message }}
			</option>
		</select>
	</div>
	<!-- <div class="se-AlertBar">
        <label>{{Alert2}}</label>
    </div> -->
	<div class="se-AlertBar" style="display: grid">
		<select class="form-control" name="StationReminderAlert" [style.color]="StationReminderAlert?.MessageFontColor" [(ngModel)]="StationReminderAlert">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstReminders" [ngValue]="o" [style.color]="o.MessageFontColor">
				{{ o.Message }}
			</option>
		</select>
	</div>
</div>

<div *ngIf="Processing == true" class="se-Entry se-ProcessBackgroud se-ProcessEntry">
	<div class="se-ProcessTextDiv">
		<label class="se-ProcessText">Processing...</label>
		<br />
		<label class="se-ProcessText">Please Wait</label>
	</div>

	<div class="se-AlertBar">
		<label></label>
	</div>
	<div class="se-AlertBar">
		<label></label>
	</div>
	<div class="se-AlertBar">
		<label></label>
	</div>
</div>
